import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Nav, Navbar } from 'react-bootstrap';

const ShopifyHeader = () => {
    const { shop: shopParam } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [shopData, setShopData] = useState(null);

    // Get shop from path parameter and construct full domain
    const shop = shopParam ? `${shopParam}.myshopify.com` : null;
    const shopName = shopParam || 'unknown';

    useEffect(() => {
        const loadShopData = async () => {
            try {
                // Get auth data from storage
                const { ShopifyAuth } = await import('../utils/shopifyAuth');
                const authData = ShopifyAuth.getAuthData();

                setShopData({
                    shopDomain: shop,
                    displayName: shopName,
                    authToken: authData.token ? '✅ Valid' : '❌ Missing'
                });
            } catch (error) {
                console.error('Failed to load shop data:', error);
                setShopData({
                    shopDomain: shop,
                    displayName: shopName,
                    authToken: '❌ Error'
                });
            }
        };

        if (shop) {
            loadShopData();
        }
    }, [shop, shopName]);

    const handleNavigation = (path) => {
        navigate(`/shopify/${shopName}/${path}`);
    };

    // Determine active tab based on current path
    const getCurrentTab = () => {
        if (location.pathname.includes('/products')) return 'products';
        if (location.pathname.includes('/dashboard')) return 'dashboard';
        return 'dashboard'; // default
    };

    const activeTab = getCurrentTab();

    return (
        <>
            {/* Main Header */}
            <div className="text-white py-3 border-bottom border-success">
                <Container>
                    <Row className="align-items-center">
                        <Col>
                            <h3 className="mb-0 text-black">Shopify - MercadoLibre × ALANI360</h3>
                            <h4 className="mb-0 text-success">{shopData?.displayName}</h4>
                        </Col>
                        <Col className="text-center">
                            <img width={150} src="/images/logo_large_plus@2x.webp" alt="MercadoLibre" className="img-fluid" />
                            <br />
                            <img width={90} src="/images/by_alani.jpg" alt="by ALANI360" className="img-fluid" />
                        </Col>
                        <Col xs="auto">
                            <span className="badge bg-success text-white">Active</span>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Navigation Menu */}
            <Navbar bg="light" expand="lg" className="border-bottom">
                <Container>
                    <Navbar.Toggle aria-controls="shopify-nav" />
                    <Navbar.Collapse id="shopify-nav">
                        <Nav className="me-auto">
                            <Nav.Link
                                active={activeTab === 'dashboard'}
                                onClick={() => handleNavigation('dashboard')}
                                style={{ cursor: 'pointer' }}
                            >
                                <i className="fas fa-tachometer-alt me-2"></i>
                                Dashboard
                            </Nav.Link>
                            <Nav.Link
                                active={activeTab === 'products'}
                                onClick={() => handleNavigation('products')}
                                style={{ cursor: 'pointer' }}
                            >
                                <i className="fas fa-box me-2"></i>
                                Products
                            </Nav.Link>
                        </Nav>
                        <Nav>
                            <Nav.Item className="d-flex align-items-center">
                                <small className="text-muted me-2">
                                    <i className="fas fa-shield-alt me-1"></i>
                                    Auth: {shopData?.authToken}
                                </small>
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default ShopifyHeader;

